import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const CalendarAddOnIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <path d="M17 22q-2.075 0-3.537-1.463Q12 19.075 12 17t1.463-3.538Q14.925 12 17 12t3.538 1.462Q22 14.925 22 17t-1.462 3.537Q19.075 22 17 22Zm1-3h1q.425 0 .713-.288Q20 18.425 20 18t-.287-.712Q19.425 17 19 17h-1v-1q0-.425-.287-.712Q17.425 15 17 15t-.712.288Q16 15.575 16 16v1h-1q-.425 0-.712.288Q14 17.575 14 18t.288.712Q14.575 19 15 19h1v1q0 .425.288.712Q16.575 21 17 21t.712-.288Q18 20.425 18 20ZM5 22q-.825 0-1.412-.588Q3 20.825 3 20V6q0-.825.588-1.412Q4.175 4 5 4h1V3q0-.425.288-.713Q6.575 2 7 2t.712.287Q8 2.575 8 3v1h8V3q0-.425.288-.713Q16.575 2 17 2t.712.287Q18 2.575 18 3v1h1q.825 0 1.413.588Q21 5.175 21 6v6.675q-.475-.325-.975-.538Q19.525 11.925 19 11.8V10H5v10h6.075q.1.525.313 1.025Q11.6 21.525 12 22Zm0-14h14V6H5Z" />
    </SvgIcon>
);

export default CalendarAddOnIcon;
